export function findVideoType (url) {
  if (!url) {
    return
  }
  if (url.includes('youtube') || url.includes('youtu.be')) {
    return 'youtube'
  } else if (url.includes('vimeo')) {
    return 'vimeo'
  } else {
    return 'jolojo'
  }
}

export function getVideoSrc (url) {
  const type = findVideoType(url)
  const id = findVideoId(url)

  switch (type) {
    case 'youtube':
      return `https://www.youtube-nocookie.com/embed/${id}`
    case 'vimeo':
      if (url.includes('vimeo.com')) {
        return url.replace('vimeo.com', 'player.vimeo.com/video')
      }
      return url
    default:
      return url
  }
}

export function getYouTubeThumbnail (url) {
  if (url.includes('youtu.be')) {
    return `https://img.youtube.com/vi/${url.split('/').pop()}/0.jpg`
  }
  if (url.includes('watch')) {
    return `https://img.youtube.com/vi/${url.split('v=')[1]}/0.jpg`
  }
  return url
}

export function findVideoId (url) {
  const type = findVideoType(url)

  switch (type) {
    case 'youtube':
      if (url.includes('youtu.be')) {
        return url.split('/').pop()
      }
      if (url.includes('watch')) {
        return url.split('v=')[1]
      }
      return url
    case 'vimeo':
      if (url.includes('vimeo.com')) {
        return url.split('/').pop()
      }
      return url
    default:
      return url
  }
}
